<div nz-row>
    <div nz-col nzXs="0" nzSm="8" nzMd="6" nzLg="5" nzXl="4" nzXXl="4"></div>
    <div nz-col nzXs="24" nzSm="8" nzMd="12" nzLg="14" nzXl="16" nzXXl="16" style="text-align: center;">
        <h2><b>Search StockFinder</b></h2>
    </div>
    <div nz-col nzXs="24" nzSm="8" nzMd="6" nzLg="5" nzXl="4" nzXXl="4" class="text-center">
        <button nz-button nzType="primary" (click)="openCart()" *ngIf="isShopping">
          <span nz-icon nzType="shopping-cart" nzTheme="outline"></span>
            <span>Continue with Cart</span>
          </button>
    </div>
</div>
<br>
<div nz-row nzJustify="center" nzAlign="middle">
    <div nz-col nzXs="22" nzSm="16" nzMd="12" nzLg="9" class="text-center">
        <app-searchbar autofocus></app-searchbar>
    </div>
</div>
<div nz-row nzJustify="center" *ngIf="recentCustomerSearches.length > 0">
    <div nz-col nzXs="22" nzSm="16" nzMd="12" nzLg="9">
        <section class="recent-searches" aria-label="Recent customer searches">
            <span class="recent-searches-label">Recent:</span>
            <button
                *ngFor="let search of recentCustomerSearches"
                type="button"
                class="recent-search-item"
                title="Search again for {{ search.displayValue || search.searchValue }}"
                (click)="repeatRecentSearch(search)">
                <span nz-icon nzType="search" nzTheme="outline" class="recent-search-icon"></span>
                <span class="recent-search-value">{{ search.displayValue || search.searchValue }}</span>
                <span class="recent-search-time">({{ getRelativeTime(search.searchedAt) }})</span>
            </button>
        </section>
    </div>
</div>
<!-- <div nz-row nzJustify="center" nzAlign="middle" class="button-container">
    <div nz-col nzXs="24" nzSm="8" nzMd="8" nzLg="6" class="text-center button-wrapper">
        <button nz-button class="block-button" (click)="onBatteryFinder()">
            <span nz-icon nzType="thunderbolt" nzTheme="outline" class="block-icon"></span>
            <div class="block-heading">BATTERY FINDER</div>
        </button>
    </div>
    <div nz-col nzXs="24" nzSm="8" nzMd="8" nzLg="6" class="text-center button-wrapper">
        <button nz-button class="block-button" (click)="onTruckTyres()">
            <span nz-icon nzType="car" nzTheme="outline" class="block-icon"></span>
            <div class="block-heading">TRUCK TYRES</div>
        </button>
    </div>
    <div nz-col nzXs="24" nzSm="8" nzMd="8" nzLg="6" class="text-center button-wrapper">
        <button nz-button class="block-button" (click)="onWhatsNew()">
            <span nz-icon nzType="star" nzTheme="outline" class="block-icon"></span>
            <div class="block-heading">WHAT'S NEW</div>
        </button>
    </div>
</div> -->

<!-- Battery Finder Modal -->
<nz-modal
  [(nzVisible)]="isBatteryFinderModalVisible"
  nzTitle="Battery Finder"
  (nzOnCancel)="handleBatteryFinderCancel()"
  (nzOnOk)="handleBatteryFinderOk()"
  nzWidth="800px">
  <ng-container *nzModalContent>
    <div nz-row [nzGutter]="16">
      <div nz-col nzSpan="24" style="margin-bottom: 16px;">
        <div nz-row nzAlign="middle" [nzGutter]="8">
          <div nz-col nzSpan="6">
            <label>Vehicle Make</label>
          </div>
          <div nz-col nzSpan="18">
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedVehicleMake"
              (ngModelChange)="onMakeChange($event)"
              nzPlaceHolder="Select vehicle make"
              [nzLoading]="loadingMakes"
              style="width: 100%;">
              <nz-option *ngFor="let make of vehicleMakes" [nzValue]="make.makeId" [nzLabel]="make.makeName || ''"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div nz-col nzSpan="24" style="margin-bottom: 16px;">
        <div nz-row nzAlign="middle" [nzGutter]="8">
          <div nz-col nzSpan="6">
            <label>Vehicle Model</label>
          </div>
          <div nz-col nzSpan="18">
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedVehicleModel"
              (ngModelChange)="onModelChange($event)"
              nzPlaceHolder="Select vehicle model"
              [nzLoading]="loadingModels"
              [nzDisabled]="!selectedVehicleMake"
              style="width: 100%;">
              <nz-option *ngFor="let model of vehicleModels" [nzValue]="model.modelId" [nzLabel]="model.modelName || ''"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div nz-col nzSpan="24" style="margin-bottom: 16px;">
        <div nz-row nzAlign="middle" [nzGutter]="8">
          <div nz-col nzSpan="6">
            <label>Vehicle Variant</label>
          </div>
          <div nz-col nzSpan="18">
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedVehicleVariant"
              (ngModelChange)="onVariantChange($event)"
              nzPlaceHolder="Select vehicle variant"
              [nzLoading]="loadingVariants"
              [nzDisabled]="!selectedVehicleModel"
              style="width: 100%;">
              <nz-option *ngFor="let variant of vehicleVariants" [nzValue]="variant.variantId" [nzLabel]="variant.longModelName || ''"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div nz-col nzSpan="24" *ngIf="selectedVariantDetails">
        <nz-divider></nz-divider>
        <h4>Vehicle Details</h4>
        <nz-descriptions nzBordered [nzColumn]="2" nzSize="small">
          <nz-descriptions-item nzTitle="Model Name">{{ selectedVariantDetails.longModelName }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Short Name">{{ selectedVariantDetails.shortModelName }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Market">{{ selectedVariantDetails.market }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Year Range">{{ selectedVariantDetails.yearStart }} - {{ selectedVariantDetails.yearEnd || 'Present' }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Start/Stop" [nzSpan]="2">
            <nz-tag [nzColor]="selectedVariantDetails.isEngineStopStart ? 'green' : 'default'">
              {{ selectedVariantDetails.isEngineStopStart ? 'Yes' : 'No' }}
            </nz-tag>
          </nz-descriptions-item>
        </nz-descriptions>
      </div>
      <div nz-col nzSpan="24" *ngIf="selectedVariantDetails">
        <nz-divider></nz-divider>
        <h4>Battery Options</h4>
        <div *ngIf="loadingBatteries" style="text-align: center; padding: 20px;">
          <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
        </div>
        <div *ngIf="!loadingBatteries && variantBatteries.length === 0" style="text-align: center; padding: 20px;">
          <nz-empty nzNotFoundContent="No batteries found for this variant"></nz-empty>
        </div>
        <div nz-row [nzGutter]="16" *ngIf="!loadingBatteries && variantBatteries.length > 0">
          <div nz-col [nzSpan]="variantBatteries.length === 1 ? 24 : (variantBatteries.length === 2 ? 12 : 8)" *ngFor="let battery of variantBatteries">
            <nz-card [nzTitle]="battery.stock_code || 'Battery'" [nzBordered]="true" class="battery-card">
              <div class="battery-info">
                <p *ngIf="battery.description_long" style="margin-bottom: 12px;"><strong>{{ battery.description_long }}</strong></p>
                <p *ngIf="battery.partNo"><strong>Part No:</strong> {{ battery.partNo }}</p>
                <p *ngIf="battery.oem"><strong>OEM:</strong> {{ battery.oem }}</p>
                <p *ngIf="battery.ahRating"><strong>AH Rating:</strong> {{ battery.ahRating }}</p>
                <p *ngIf="battery.ccaSae"><strong>CCA (SAE):</strong> {{ battery.ccaSae }}</p>
                <p *ngIf="battery.ccaEn"><strong>CCA (EN):</strong> {{ battery.ccaEn }}</p>
                <p *ngIf="battery.length || battery.width || battery.height">
                  <strong>Dimensions:</strong> {{ battery.length }}x{{ battery.width }}x{{ battery.height }}mm
                </p>
                <p *ngIf="battery.terminalLayout"><strong>Terminal:</strong> {{ battery.terminalLayout }}</p>
                <div *ngIf="battery.priority" class="battery-rating">
                  <nz-rate [ngModel]="getBatteryStarRating(battery.priority)" nzDisabled [nzCount]="5"></nz-rate>
                </div>
                <button nz-button nzType="primary" nzBlock (click)="searchBattery(battery)" style="margin-top: 16px;">
                  <span nz-icon nzType="search" nzTheme="outline"></span>
                  SEARCH
                </button>
              </div>
            </nz-card>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
